import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import './AdminCharts.css';

const AdminTokenDoughnut = ({ input, output, total }) => {
  const data = {
    labels: ['Input (Entrada)', 'Output (Salida)'],
    datasets: [
      {
        data: [input || 0, output || 0],
        backgroundColor: ['#3b82f6', '#f59e0b'],
        borderColor: ['#ffffff', '#ffffff'],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { usePointStyle: true, padding: 20 } }
    },
    cutout: '70%',
  };

  // 🔥 CORRECCIÓN: Mostrar "0" en lugar de "0.0k" cuando total es 0
  const displayTotal = total > 0 ? (total / 1000).toFixed(1) + 'k' : '0';

  return (
    <div className="ad-card">
      <h2>🧠 Anatomía del Token</h2>
      <div style={{ height: '200px', position: 'relative' }}>
        <Doughnut options={options} data={data} />
        <div className="ad-doughnut-center">
          <span>Total</span>
          <strong>{displayTotal}</strong>
        </div>
      </div>
    </div>
  );
};

export default AdminTokenDoughnut;